import script from "./AdminStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStatistics.vue?vue&type=script&setup=true&lang=js"

import "./AdminStatistics.vue?vue&type=style&index=0&id=b42f7a1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b42f7a1c"]])

export default __exports__